<template>
  <div class="login-screen">
    <v-btn
      v-if="noUser"
      class="login-button"
      color="secondary"
      @click="handleLoginClick"
      >Log in with Stamen Google Account</v-btn
    >
  </div>
</template>

<script>
import { doLoginFlow } from '@/utils/authUtils'
import { mapGetters } from 'vuex'
// import { auth } from '@/providers/firebase'
export default {
  name: 'Login',
  computed: {
    ...mapGetters(['noUser'])
  },
  methods: {
    handleLoginClick() {
      doLoginFlow()
        .then(() => {
          // login successful
          console.log('route obj', this.$route)
          const newLoc = this.$route?.fullPath ?? '/'
          this.$router.push(newLoc)
        })
        .catch(() => {
          // login failed, do nothing
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-screen {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-button {
    color: black;
  }
}
</style>
